// extracted by mini-css-extract-plugin
export default {"buttons":"LogoutConfirmModal_buttons__-Hr+9","logoutButton":"LogoutConfirmModal_logoutButton__1fa5t"};